/** UI-only phase: serve fixture data instead of calling the backend API. */
export function isUiMockMode(): boolean {
  return import.meta.env.VITE_UI_MOCK === "true";
}
